// @ts-nocheck
import React, { useState, useEffect } from 'react';
import MobligoLogo from '../assets/img/mobligo_new.png';
import MyInput from '../components/ui/MyInput';
import PrimaryButton from '../components/ui/PrimaryButton';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import CreateAction from '../components/operational/createAction';
import { useDispatch } from 'react-redux';
import myUserSlice from '../redux/myUserSlice';
import { translate } from '../utils/language';
import { ReactComponent as AppleLogo } from '../assets/img/apple.svg';
import { ReactComponent as GoogleLogo } from '../assets/img/google.svg';
import { useNavigate } from 'react-router-dom';
import { useGoogleLogin } from '@react-oauth/google';
function getSearchParamsAsJson(url) {
  const params = new URL(url).searchParams; // Use window.location.href for the current page
  const json = {};

  for (const [key, value] of params.entries()) {
    // If a key appears multiple times, convert it to an array
    if (json[key]) {
      json[key] = Array.isArray(json[key]) ? [...json[key], value] : [json[key], value];
    } else {
      json[key] = value;
    }
  }

  return json;
}

const UserRegister = ({ setPage }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');

  const [name, setName] = useState('');
  const [surname, setSurname] = useState('');
  const [phone, setPhone] = useState('');
  const [isError, setIsError] = useState([]);

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [termsChecked, setTermsChecked] = useState(false);
  const [isSocialLoginTriggered, setIsSocialLoginTriggered] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const errorGenerator = newError => {
    setIsError(state => {
      const newState = [...state];
      newState.push(newError);
      return newState;
    });
    return true;
  };
  const errorChecker = conditions => {
    setIsError([]);
    const failedCondition = conditions.filter(condition => {
      const check = condition.check;
      if (check) return errorGenerator(condition.error);
    });
    if (failedCondition.length > 0) return true;
  };

  const createConditions = [
    {
      check: !/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/.test(email),
      error: 'missingEmail',
    },
    {
      check: !/^(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&()_+={}[\]:;<>,.?/~]).{8,}$/.test(password),
      error: 'weakPassword',
    },
    {
      check: passwordConfirmation !== password,
      error: 'unmatchedPassword',
    },
    {
      check: !termsChecked,
      error: 'missingTerms',
    },
  ];

  const handleRegister = async () => {
    const isErrorChecker = errorChecker(createConditions);
    if (isErrorChecker) return;

    const currentPageParams = getSearchParamsAsJson(window.location.href);

    try {
      const registerResponse = await CreateAction({
        method: 'post',
        path: '/sso/register',
        data: { email, password, referrer: currentPageParams },
        showPreLoader: true,
        isFileUploading: false,
      });

      if (registerResponse?.error) return;

      handleLoginClickButton();
    } catch (error) {}
  };

  const handleLoginClickButton = async () => {
    const response = await CreateAction({
      method: 'post',
      path: '/sso/login',
      data: { email, password },
      showPreLoader: true,
      isFileUploading: false,
    });
    if (response?.error) return;
    setUserInformation(response);
    window.location.href = '/chooseApp';
  };

  const setUserInformation = response => {
    const token = response.result.resultData.token;
    const refreshToken = response.result.resultData.refreshToken;
    const user = response.result.resultData.user;
    if (!user || !token) return null;

    localStorage.setItem('token', token);
    localStorage.setItem('refreshToken', refreshToken);

    dispatch(myUserSlice.actions.setUser(user));
  };

  useEffect(() => {
    setIsError([]);
  }, [email, password, phone, termsChecked]);

  const handleSocialLogin = async tokenResponse => {
    const currentPageParams = getSearchParamsAsJson(window.location.href);


    const response = await CreateAction({
      method: 'post',
      path: '/sso/socialLogin',
      showPreLoader: true,
      isFileUploading: false,
      data: {
        token: tokenResponse?.access_token,
        referrer: currentPageParams
      },
    });

    if (response?.error) return setIsError([]);

    setUserInformation(response);
    window.location.href = '/chooseApp';
  };

  const loginWithGoogle = useGoogleLogin({
    onSuccess: tokenResponse => {
      handleSocialLogin(tokenResponse);
    },
    onError: tokenResponse => console.log(tokenResponse),
  });
  return (
    <div className="authPage d-flex overflow-auto">
      <div className="login bg-[#ffffff] h-[100vh] overflow:hidden flex justify-center">
        <div className="relative flex flex-row flex-wrap items-center justify-center h-[100%]">
          <div className="z-[1000] w-[300px] sm:w-[500px] bg-[#FFFFFF] rounded-xl">
            <form
              className="flex flex-col justify-center  items-center gap-3 h-max"
              onSubmit={e => {
                e.preventDefault();
                if (isSocialLoginTriggered) return;
                handleRegister();
              }}
            >
              <a className="w-full flex items-center justify-center" href="https://www.mobligo.com">
                <img className="w-[70%] xl:w-[43%] lg:w-[43%] mt-5" src={MobligoLogo} alt="" />
              </a>

              <p className="text-[#2C2C2C] font-medium text-3xl">mobligo Hesabı Oluşturun</p>
              <p className="text-[#8A92A6] font-medium text-sm">Kayıt olun ve anında mobil uygulamanızı oluşturun!</p>

              <>
                <div className="  w-[300px] sm:w-[500px]">
                  <MyInput
                    isRequired={!isSocialLoginTriggered}
                    isError={isError.includes('missingEmail')}
                    isDefaultError={isError.includes('missingEmail')}
                    isDefaultErrorMessage={translate('missingEmail')}
                    type="email"
                    color="black"
                    classes="h-14"
                    onChange={(e: any) => setEmail(e)}
                    placeholder="E-posta adresiniz"
                    value={email}
                  ></MyInput>
                </div>
                <div className="flex sm:flex-row gap-4 w-[300px] sm:w-[500px] flex-col">
                  <MyInput
                    isRequired={!isSocialLoginTriggered}
                    isError={isError.includes('weakPassword') || isError.includes('unmatchedPassword')}
                    isDefaultError={isError.includes('weakPassword') || isError.includes('unmatchedPassword')}
                    isDefaultErrorMessage={
                      isError.includes('weakPassword') ? translate('weakPassword') : translate('unmatchedPassword')
                    }
                    type="password"
                    classes="h-14"
                    color="black"
                    onChange={(e: any) => setPassword(e)}
                    placeholder="Şifrenizi Giriniz"
                    value={password}
                  ></MyInput>
                </div>
                <div className="flex sm:flex-row gap-4 w-[300px] sm:w-[500px] flex-col">
                  <MyInput
                    isRequired={!isSocialLoginTriggered}
                    isError={isError.includes('unmatchedPassword')}
                    isDefaultError={isError.includes('unmatchedPassword')}
                    isDefaultErrorMessage={translate('unmatchedPassword')}
                    type="password"
                    classes="h-14"
                    color="black"
                    onChange={(e: any) => setPasswordConfirmation(e)}
                    placeholder="Tekrar Şifrenizi Giriniz"
                    value={passwordConfirmation}
                  ></MyInput>
                </div>
              </>
              <PrimaryButton
                isSubmitButton={true}
                classes={'signup py-4 my-2 rounded h-12 bg-[#6F66F6] transition duration-150 w-full'}
                value={'Kayıt Ol'}
              />

              <div className="flex text-left justify-center items-center gap-4 flex-col">
                <div className="flex flex-row justify-center items-center gap-4">
                  <input
                    id=""
                    checked={termsChecked}
                    type="checkbox"
                    required
                    onChange={e => setTermsChecked(e.target.checked)}
                  ></input>
                  <label id="" className="text-[#8A92A6] text-sm">
                    <a href="https://mobligo.com/kvkk/" target="_blank">
                      *Kişisel verilerinizin işlenmesine yönelik <span className="text-[#6F66F6]">Aydınlatma </span>ve{' '}
                      <span className="text-[#6F66F6]">Açık Rıza Metni’ni okudum, onaylıyorum.</span>
                    </a>
                  </label>
                </div>
                <div className="flex flex-row justify-center items-center gap-4">
                  <input id="" type="checkbox" defaultChecked></input>
                  <label id="" className="text-[#8A92A6] text-sm">
                    Kampanyalardan haberdar olmak için tarafıma{' '}
                    <a href="https://mobligo.com/gizlilik-sozlesmesi/" target="_blank">
                      <span className="text-[#6F66F6]">ticari elektronik ileti</span>
                    </a>{' '}
                    gönderilmesini kabul ediyorum.
                  </label>
                </div>
              </div>
              <div className="relative py-1">
                <div className="relative flex justify-center">
                  <span className="bg-white px-4 text-sm text-[#8A92A6]">ya da</span>
                </div>
              </div>
              <div className="w-[300px] sm:w-[500px]">
                <button
                  type="submit"
                  className="py-4 bg-[#fffff] flex rounded h-14 border border-slate w-full justify-center items-center hover:bg-[#E3E8EF] transition duration-150 "
                  onClick={() => {
                    setIsSocialLoginTriggered(true);
                    setTimeout(() => {
                      setIsSocialLoginTriggered(false);
                      if (!termsChecked) return;
                      loginWithGoogle();
                    });
                  }}
                >
                  <GoogleLogo className="h-6 w-6 mr-2" />
                  <span className="font-bold">Google ile kayıt ol</span>
                </button>
              </div>
              <div className="text-center w-[100%] mb-5 mt-5">
                <div className="flex flex-row text-center justify-center gap-2 items-center">
                  <p className="text-[#8A92A6]">Hesabınız var mı?</p>
                  <span
                    className="text-md font-medium text-slate-600 dark:text-slate-200 hover:text-[#6f66f6] cursor-pointer"
                    onClick={(e: any) => {
                      navigate('/login');
                    }}
                  >
                    Giriş Yap
                  </span>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserRegister;
